import React from 'react';
import dynamic from 'next/dynamic';
import cx from 'clsx';
import classes from './Social.module.scss';

const Link = dynamic(() => import('next/link'));
const YoutubeIcon = dynamic(() => import('./socialIcons/Youtube'));
const InstagramIcon = dynamic(() => import('./socialIcons/Instagram'));
const TwitterIcon = dynamic(() => import('./socialIcons/Twitter'));
const FacebookIcon = dynamic(() => import('./socialIcons/Facebook'));

export interface SocialProps extends React.HTMLProps<HTMLDivElement> {
  twitter?: string,
  youtube?: string,
  instagram?: string,
  facebook?: string,
  innerWidth: number,
}

export default function Social({
  className,
  twitter,
  youtube,
  instagram,
  facebook,
  innerWidth,
  ...others
}: SocialProps) {
  const size = innerWidth > 799 ? 12 : 18;

  return (
    <div className={cx(classes.social, className)} {...others}>
      {youtube && (
        <Link href={youtube}>
          <div className={classes.socialIcon}><YoutubeIcon size={size} /></div>
        </Link>
      )}
      {instagram && (
        <Link href={instagram}>
          <div className={classes.socialIcon}><InstagramIcon size={size} /></div>
        </Link>
      )}
      {twitter && (
        <Link href={twitter}>
          <div className={classes.socialIcon}><TwitterIcon size={size} /></div>
        </Link>
      )}
      {facebook && (
        <Link href={facebook}>
          <div className={classes.socialIcon}><FacebookIcon size={size} /></div>
        </Link>
      )}
    </div>
  );
}

Social.displayName = '@ioa/lablocator/Social';
